import { createContext, ReactNode, use } from 'react';

interface IdleContextValue {
    idle: boolean;
}

export const IdleContext = createContext<IdleContextValue>({
    idle: false,
});

export function useIdleContext() {
    const context = use(IdleContext);
    return context;
}

export function useIsIdle() {
    const { idle = false } = useIdleContext();
    return idle;
}

interface IdleContextProviderProps {
    idle?: boolean;
    children?: ReactNode;
}

export function IdleContextProvider({ children = null, idle = false }: IdleContextProviderProps) {
    const { idle: previousIdle = false } = useIdleContext();
    const value = {
        idle: idle || previousIdle,
    };

    return <IdleContext value={value}>{children}</IdleContext>;
}
